export const isPlaying = (state) => {
  return state.playingStatus
}

export const playerStation = (state) => {
  return state.playerStation
}
